module["exports"] = [
  "###",
  "###/#",
  "##",
  "##/#",
  "#",
  "#/#"
];
